// ─────────────────────────────────────────────────────────────────────────────
// Manifesto ÚNICO dos cards clínicos do paciente, usado pelo dashboard
// (PatientProfileDashboardPage). Adicionar 1 card aqui = aparece na tela.
//
// Cada card é um COMPONENTE independente (recebe patient-id e o título, e busca
// seus próprios dados) e importa por conta própria o seu dialog de edição. Este
// manifesto só amarra: que componente renderizar (`card`), o título e o ícone
// (usados na busca e no header) e as flags de layout.
//
// Os campos `dialog` e `dialogProps` foram removidos junto com o lançamento
// rápido da consulta (salvia-782): eram lidos só pelo AppointmentDialog.
//
// Campos:
//   id         estável (persistência da ordem custom em user_preferences) — NÃO renomear
//   title      título exibido
//   icon       ícone mdi
//   card       nome do componente do card (registrado no dashboard)
//   readonly   card só-leitura (sem botão de inserir; adição é por outro card)
//   fullWidth  ocupa a linha inteira no desktop
//   compact    card de um dado so -> metade da largura (a altura segue a dos demais)
// ─────────────────────────────────────────────────────────────────────────────

export const dashboardCards = [
  {
    id: "clinical-insights",
    title: "Insights Clínicos",
    icon: "mdi-lightbulb-on-outline",
    card: "PatientInsightsCard",
    readonly: true,
    // salvia-851: o insight é texto clínico com justificativa. Em um terço da
    // largura sobrava o alerta e se perdia o raciocínio que permite ao médico
    // avaliar se concorda. Mesma largura do Histórico de Vida, pelo mesmo motivo.
    fullWidth: true,
  },
  {
    id: "life-history",
    title: "Histórico de Vida",
    icon: "mdi-book-open-variant",
    card: "LifeHistoryCard",
    fullWidth: true,
  },
  {
    id: "body-composition",
    title: "Composição Corporal",
    icon: "mdi-human",
    card: "BodyCompositionCard",
  },
  {
    id: "main-goal",
    title: "Objetivo Principal",
    icon: "mdi-bullseye",
    card: "MainGoalCard",
  },
  {
    id: "goals-deadlines",
    title: "Metas e Prazos",
    icon: "mdi-flag-checkered",
    card: "GoalsDeadlinesCard",
  },
  {
    id: "chronic-diseases",
    title: "Doenças Crônicas",
    icon: "mdi-medical-bag",
    card: "ChronicDiseasesCard",
  },
  {
    id: "cids",
    title: "CID / Outras doenças",
    icon: "mdi-clipboard-list-outline",
    card: "CidsCard",
  },
  {
    id: "continuous-medications",
    title: "Medicamentos Contínuos",
    icon: "mdi-pill",
    card: "MedicationsCard",
  },
  {
    id: "supplements",
    title: "Suplementos",
    icon: "mdi-nutrition",
    card: "SupplementsCard",
  },
  {
    id: "food-restrictions",
    title: "Restrições Alimentares",
    icon: "mdi-food-off",
    card: "DietaryRestrictionsCard",
  },
  {
    id: "symptoms",
    title: "Sintomas Frequentes",
    icon: "mdi-pulse",
    card: "SymptomsCard",
  },
  {
    id: "allergies",
    title: "Alergias",
    icon: "mdi-alert-circle",
    card: "AllergiesCard",
  },
  {
    id: "psychological-disorders",
    title: "Transtornos Psicológicos",
    icon: "mdi-brain",
    card: "PsychologicalDisordersCard",
  },
  {
    id: "sleep",
    title: "Sono",
    icon: "mdi-sleep",
    card: "SleepCard",
  },
  {
    id: "gynecology",
    title: "Ciclo menstrual",
    icon: "mdi-gender-female",
    card: "GynecologyCard",
  },
  {
    id: "complementary-treatments",
    title: "Tratamentos Complementares/Alternativos",
    icon: "mdi-spa",
    card: "ComplementaryTreatmentsCard",
  },
  {
    id: "exercise",
    title: "Prática de Exercício",
    icon: "mdi-run",
    card: "ExercisePracticeCard",
  },
  {
    // salvia-759: agora editável pela UI (create/update/delete), como o sono.
    id: "alcohol",
    title: "Consumo de Álcool",
    icon: "mdi-glass-wine",
    card: "AlcoholCard",
    compact: true,
  },
  {
    // salvia-759: agora editável pela UI (create/update/delete), como o sono.
    id: "hydration",
    title: "Hidratação",
    icon: "mdi-cup-water",
    card: "HydrationCard",
    compact: true,
  },
  // OCULTO 18/08/2026 (decisao do Ariel): o card e so-leitura — nao ha endpoint de
  // escrita (`/api/patient-dietary-recalls` so expoe GET get-by-patient) nem dialog
  // de edicao, entao ele so exibe o que a anamnese/proposta gravou. Some do dashboard
  // enquanto nao recebe o CRUD do salvia-759. Pra trazer de volta: descomentar.
  // O componente (DietaryRecallCard.vue) e o service seguem no repo, intactos.
  // {
  //   id: "dietary-recall",
  //   title: "Recordatório Alimentar",
  //   icon: "mdi-food-apple",
  //   card: "DietaryRecallCard",
  //   readonly: true,
  // },
];
